import { JourneyContext } from './JourneyReport';
import { useContext } from 'react';

export const useJourneyReport = () => useContext(JourneyContext);
